// Support contact for client-facing "reach out" surfaces (the "Have
// Questions?" modal and the Welcome modal). Onboarding always shows the fixed
// SUPPORT_CONTACT. In the main app, orgs show their Client Owner unless
// `onboardingData.onboarding_complete.completed` is explicitly false: new
// clients get that value when they finish the onboarding flow and keep it
// until Client Admin marks onboarding complete. Existing clients have no
// value and show their Client Owner.
// The contact's calendar travels with it (the "Have Questions?" calendar);
// strategy-call scheduling always follows the Client Owner.

import type { ClientOwner } from './clientOwners';

export interface SupportContact {
  name: string;
  email: string;
  /** HubSpot meetings URL for the "Have Questions?" calendar (append `?embed=true` to embed). */
  bookingUrl: string;
}

export const SUPPORT_CONTACT = {
  name: 'Christian',
  email: 'christian.delacruz@speculo.ai',
  bookingUrl: 'https://meetings.hubspot.com/christian-dela-cruz/speculoai-onboarding-support',
  role: 'Onboarding Assistant',
  /** Path under /public/. */
  imageUrl: '/onboarding/CHRISTIAN.webp',
} as const satisfies SupportContact & { role: string; imageUrl: string };

export interface OnboardingCompleteData {
  completed?: boolean;
  completed_at?: string;
}

/** Missing value means an existing client that finished onboarding before the gate. */
export const isOnboardingMarkedComplete = (
  onboardingComplete: OnboardingCompleteData | null | undefined
): boolean => onboardingComplete?.completed !== false;

export const resolveSupportContact = (
  onboardingComplete: OnboardingCompleteData | null | undefined,
  owner: ClientOwner
): SupportContact =>
  isOnboardingMarkedComplete(onboardingComplete)
    ? { name: owner.displayName, email: owner.email, bookingUrl: owner.bookingUrl }
    : SUPPORT_CONTACT;
